var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ElementTreeBlockButton,{staticClass:"add-on-tile",attrs:{"element":_vm.tile.element,"placement":_vm.tile.placement,"workflow":_vm.tile.workflow},on:{"click":_setup.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }